import ChannelCircle from "./ChannelCircle";
import ContextMenu from './ContextMenu';
import { useState, useRef } from 'react';
import ExpandedIcon from '@material-ui/icons/ArrowDropDown';
import _ from 'lodash';


const colors = [
  "grey",
  "blue",
  "green",
  "red",
  "magenta",
  "cyan",
  "yellow",
]

const colorMap = {
  green:"lime",
}

export function ColorCircles(
  {colors=['white'],selectedSize=8,direction="row",shape="circle",
}){
  const dim = selectedSize;

  let dir = ({row:"row",col:"col"})[direction]||"row";


  return (
    <div class={`sg-${dir} v-center`}>
      
      {colors.map(cc => <ChannelCircle {...{size:dim, color:(colorMap[cc]||cc)}}/>)}
    </div>
  )
}

function ColorMenuItems({selectedSize=15, multichannel,onChange,value}){
  return [
    { title:(<div class="full-width">None</div>), data:[], type:"none",action:"none" },
    /*{ title:(
      <div class="sg-row v-center">
      <ColorCircles selectedSize={selectedSize} colors={(["grey"])}/>
      </div>
    ), data:["grey"], type:"grey", action:"grey" },*/
    ...colors.map(color => {
      return {
        title:(
          <div class="sg-row v-center">
            {multichannel && <input 
              checked={value.includes(color)}
              type="checkbox" 
              onChange={e => onChange?.({
                type:"colorChange",
                target:colors[0],
                value:e.target.checked
              })
            }/>}
            <ColorCircles colors={[color]} selectedSize={selectedSize}/>
          </div>
        ),
        data:[color],
        ignore:!!multichannel,
        //submenu
      }

    }),
    //...mapColors([],0,selectedSize,multichannel),
    
  ]
}

export default function ChannelDropdown({
  value, 
  onChange,
  prompt,
  selectedSize=15,
  submenu=true,
  multichannel,
}){

  const dropDownRef = useRef();

  const [openPath, setOpenPath] = useState([]);
  const [ menuOpen, setMenuOpen ] = useState(false);


  let items = [];

  let nonColorsInValue = [];
  let colorsInValue = [];

  value.forEach(col => {
    if( colors.includes(col) ){
      colorsInValue.push(col)
    }else{
      nonColorsInValue.push(col);
    }
  })

  

  if( multichannel ){
    items.push({
      title:<b>Channels</b>
    })

    nonColorsInValue.forEach(val => {
      items.push({title:(
        val
      )});
    })

    items.push({
      title:<b>Colors</b>
    })

  }
  items.push(...ColorMenuItems({selectedSize,onChange,value,multichannel}))





  let menu = (<ContextMenu
    {...{
      closeOnOutsideClick:true,
      onEvent:(ev => onChange(ev.data)),
      onClose:(e) => { 

        if( e ){
          let path = e.composedPath();
          let curRef = dropDownRef.current 

          if( curRef && !path.includes(curRef) ){
            setMenuOpen(false); 
            setOpenPath([]);
          }

        }else{

          setMenuOpen(false); 
          setOpenPath([]);

        }
      },
      items,
      //submenuDirection:"left",
      openPath,
      setOpenPath,
      treeLevel:0,
    }}/>);
  return (
    <div class="sg-row v-center">
      {prompt && <div style={{fontSize:10}}>{prompt}</div>}

      <div ref={dropDownRef}
        onMouseDown={(e) => {

          if( menuOpen ){
            //;
            console.log("Closing an open menu from Dropdown.");
            setMenuOpen(false);
            setOpenPath([]);
          }else if(!menuOpen){

            console.log("Openingn a dropdown.");

            //;
            setMenuOpen(true);

            // because I don't want it 
            // to close this
            //e.preventDefault();
            //e.stopPropagation();

          }
          //setMenuOpen(!menuOpen);
        }} 
        style={{
          border:'1px solid #ccc',
          zIndex:(menuOpen?1000000:'unset'),
          background:'white',
        }} 
        class="sg-row v-center clickable flex-expand tiny-padding-left rel">
        <ColorCircles colors={value} selectedSize={selectedSize}/>
        <div class="flex-expand"/>
        <ExpandedIcon style={{fontSize:18}}/>
        {menuOpen && <div style={{
          zIndex:1000000, transform:'translate(0,100%)',
          }} class="absolute-cover"> 
          {menuOpen && menu}
        </div>}
      </div>


    </div>
  )




}




